// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordVersion
 */
export interface RecordVersion {
    /**
     * 
     * @type {string}
     * @memberof RecordVersion
     */
    runId: string;
    /**
     * 
     * @type {string}
     * @memberof RecordVersion
     */
    status: RecordVersionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RecordVersion
     */
    timestamp?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RecordVersion
     */
    values: { [key: string]: string; };
}


/**
 * @export
 */
export const RecordVersionStatusEnum = {
    Inserted: 'INSERTED',
    Updated: 'UPDATED'
} as const;
export type RecordVersionStatusEnum = typeof RecordVersionStatusEnum[keyof typeof RecordVersionStatusEnum];


/**
 * Check if a given object implements the RecordVersion interface.
 */
export function instanceOfRecordVersion(value: object): value is RecordVersion {
    if (!('runId' in value) || value['runId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function RecordVersionFromJSON(json: any): RecordVersion {
    return RecordVersionFromJSONTyped(json, false);
}

export function RecordVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordVersion {
    if (json == null) {
        return json;
    }
    return {
        
        'runId': json['runId'],
        'status': json['status'],
        'timestamp': json['timestamp'] == null ? undefined : json['timestamp'],
        'values': json['values'],
    };
}

export function RecordVersionToJSON(json: any): RecordVersion {
    return RecordVersionToJSONTyped(json, false);
}

export function RecordVersionToJSONTyped(value?: RecordVersion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'runId': value['runId'],
        'status': value['status'],
        'timestamp': value['timestamp'],
        'values': value['values'],
    };
}
